import React, { Component } from "react"
import { withStyles } from '@material-ui/core/styles';
import { TextField } from "@material-ui/core"
import Save from "../../../../assets/img/svg/save.svg"
import Cancel from "../../../../assets/img/svg/cancel.svg"
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import styles from "../../../../assets/jss/customStyle";
import $ from "jquery"
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Delete from "../../../../assets/img/svg/delete.svg"
import axios from "axios";
import API from "../../../../_helpers/endpointService"
import del from "../../../../assets/img/svg/Del.svg"

class AddEditPCP extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isMobile: false,
            menu: true,
            NameError: false,
            isEdit: false,
            addData:  {
                "Id": 0,
                "Name": "",
                "Description": "",
                "Type": "PreCutting"
            }
        }
    };

    componentDidMount() {
        window.location.pathname === "/lookupdata/pcp/add" ? this.state.isEdit = false : this.state.isEdit = true;
        this.setState({})
        if (this.state.isEdit == true) {
            this.state.addData.Id = parseInt(localStorage.getItem("PCEditId"));
            this.setState({})
            this.getpcplookinfo(parseInt(localStorage.getItem("PCEditId")))
        }
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    }

    getpcplookinfo = (data) => {
        let apiUrl = API.LOOKUP_DATA + '/' + data;
        axios({
            method: "get",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.state.addData.Name = response.data.Name;
                    this.state.addData.Description = response.data.Description;
                    this.setState({})
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    componentWillUnmount() {
        clearInterval(this.interval);
        $("#MASDATA1 .MuiListItemText-primary").addClass("spanTopBar")
        $("#MasterData1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#MasterData11").addClass("d-none");
        $("#MasterData11").removeClass("d-block");
        $("#MPCP").removeClass("active-color");
        $("#MPCPT").removeClass("fw-bolder");
    }

    sidebar = () => {
        this.props.navigate("/sidebarmasterdata");
    }

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        $("#MASDATA1 .MuiListItemText-primary").addClass("spanTopBar")
        $("#MasterData1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#MasterData11").removeClass("d-none");
        $("#MasterData11").addClass("d-block");
        $("#MPCPT .MuiListItemText-primary").addClass("fw-bolder")
        $("#MPCP").addClass("active-color")
    };

    handleInputChange = (e, node) => {
        this.state.addData[node] = e.target.value;
        this.setState({})
    };

    Save = () => {
        if (this.state.addData.Name === "") {
            this.state.NameError = true;
            this.setState({})
        }
        else {
            this.state.NameError = false;
            this.setState({})
        }
        if (this.state.addData.Name != "") {
            if (this.state.isEdit == false) {
                this.addpcplookinfo(this.state.addData)
            }
            else {
                this.putpcplookinfo(this.state.addData, this.state.addData.Id)
            }
        }
    };

    DeleteItem = () => {
        window.$("#deletepopup").modal("hide");
        this.deletepcplookdocs(this.state.addData.Id)
    }

    deletepcplookdocs = (ids) => {
        let apiUrl = API.LOOKUP_DATA + '/' + ids;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "delete",
            url: apiUrl,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.navigate("/lookupdata/pcp")
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {

                }
            });
    };

    addpcplookinfo = (data) => {
        let apiUrl = API.LOOKUP_DATA;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.navigate(`/lookupdata/pcp`)
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    putpcplookinfo = (data, id) => {
        let apiUrl = API.LOOKUP_DATA + '/' + id;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "PUT",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.navigate(`/lookupdata/pcp`)
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    AddCancel = () => {
        this.props.navigate(`/lookupdata/pcp`)
    };

    render() {
        const { isEdit } = this.state;
        let { classes, menuToggle } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={() => this.sidebar()} >
                                            <ListItemText id="MASDATA1" className='  textNaviIcon' primary="Master Data" />
                                            <NavigateNextIcon id="MASDATA11" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-2 mt-5 ">
                                    <h4>Pre Cutting Progress</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto scroll-hide" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {
                        this.state.isMobile ?
                            <table className="dataTable border-top" width="100%">
                                <tbody>
                                    <tr>
                                        <td className="border-right text-center"><i class="fa fa-arrow-left cursorPointer" data-target="#cancelpopup" data-toggle="modal"></i></td>
                                        <td className="border-right text-center" >
                                            <button className={`${classes.button}`} onClick={() => { this.Save() }}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                        </td>
                                        <td className="border-right text-center">
                                            <button className={`${classes.button} `} data-target="#cancelpopup" data-toggle="modal"><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                        </td>
                                        {this.state.isEdit &&
                                            <td className="border-right text-center">
                                                <button className={`${classes.button} `} data-target="#deletepopup" data-toggle="modal" ><img src={Delete} style={{ marginTop: '-4px' }}></img>&nbsp;Delete</button>
                                            </td>}
                                    </tr>
                                </tbody>
                            </table>
                            :
                            <>
                                <table className="dataTable" width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="5%" className="border-right text-center"><i class="fa fa-arrow-left cursorPointer" data-target="#cancelpopup" data-toggle="modal"></i></td>
                                            <td className="" width="95%">
                                                <button className={`${classes.button}`} onClick={() => { this.Save() }}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                                <button className={`${classes.button} pl-3`} data-target="#cancelpopup" data-toggle="modal"><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                                {this.state.isEdit &&
                                                    <button className={`${classes.button} `} data-target="#deletepopup" data-toggle="modal" style={{ minWidth: '70px' }}><img src={Delete} style={{ marginTop: '-4px' }}></img>&nbsp;Delete</button>}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table></>}
                                <div style={{ margin: this.state.isMobile ? "auto" : "5px" }}>
                        {this.state.isMobile ? "" : <h6 className="col-12 mx-2 mt-3 ml-1">Pre Cutting Progress</h6>}
                        <div className="row mx-1 px-3 mt-4">
                            <div className={`row mt-2 mx-1 align-items-center ${this.state.isMobile ? "" : "text-row"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2" : "float-end d-flex"}>Activity Name&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div></label>
                                </div>
                                <div className={`col-12 col-sm-12 pb-4  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-4 pt-4"}`}>
                                    {this.state.NameError ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={this.state.addData?.Name}
                                            onChange={(e) => { this.handleInputChange(e, "Name") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />
                                        :
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={this.state.addData?.Name}
                                            onChange={(e) => { this.handleInputChange(e, "Name") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />
                                    }
                                </div>
                            </div>
                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2" : "float-end d-flex"}>Description&nbsp;:
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12 pb-4  col-xl-11 col-lg-10  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-10 pt-4"}`}>
                                    <TextField
                                        multiline
                                        rows={4}
                                        variant="outlined"
                                        size="small"
                                        value={this.state.addData.Description}
                                        onChange={(e) => { this.handleInputChange(e, "Description") }}
                                        fullWidth
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div style={{ margin: this.state.isMobile ? "auto" : "15px 45px" }}>
                        <div className="row px-4">
                            {this.state.isMobile ? <></> : <h6 className="col-12">Pre Cutting Progress</h6>}
                            <div className="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 pt-3">
                                <label>Activity Name :</label>
                            </div>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 pt-3">
                                {this.state.NameError ?
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        error
                                        value={this.state.addData?.Name}
                                        helperText="Required field must be filled in"
                                        onChange={(e) => { this.handleInputChange(e, "Name") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`
                                        }}
                                        classes={{ root: classes.helperText }}
                                    /> :
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.addData.Name}
                                        onChange={(e) => { this.handleInputChange(e, "Name") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`
                                        }}
                                    />}
                            </div>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 pt-3">
                                <label>Description :</label>
                            </div>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 pt-3">
                                <TextField
                                    multiline
                                    rows={4}
                                    variant="outlined"
                                    size="small"
                                    value={this.state.addData.Description}
                                    onChange={(e) => { this.handleInputChange(e, "Description") }}
                                    fullWidth
                                    InputProps={{
                                        className: `border-radius ${classes.inputfieldAlign}`
                                    }}
                                />
                            </div>
                        </div>
                    </div> */}
                </div>
                <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                    <div class="modal-dialog" role="document">
                        <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                            <div class="modal-body pb-0">
                                <h1 className="text-center">
                                    <img src={del}></img>
                                </h1>
                                <div className="text-center">
                                    <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                            </div>
                            <div class="modal-footer border-top-0 m-auto">
                                <button type="button" data-dismiss="modal" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => this.DeleteItem()}><span className="" >Delete</span></button>
                                <button type="button" onClick={() => { window.$("#deletepopup").modal("hide") }} data-dismiss="modal" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade p-5 mt-5" id="cancelpopup" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                    <div class="modal-dialog" role="document">
                        <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                            <div class="modal-body pb-0">
                                <h1 className="text-center">
                                    <img src={del}></img>
                                </h1>
                                <div className="text-center">
                                    <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                            </div>
                            <div class="modal-footer border-top-0 m-auto">
                                <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} style={{ backgroundColor: "#00838F", border: "none" }} data-dismiss="modal" onClick={this.AddCancel}><span className="" >Yes</span></button>
                                <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
    };
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddEditPCP))
);